//import RemoveFn from './removeContainer'
//import RemoveMobileFn from './removeContainer.mobile'

import AddFn from './addContainer'
//import AddMobileFn from './addContainer.mobile'

//(window.deviceInfo &&window.deviceInfo.isMobile)? RemoveMobileFn:
//(window.deviceInfo &&window.deviceInfo.isMobile)? AddMobileFn: 
//let RemoveModuleFn =  RemoveFn;
let AddModuleFn = AddFn;
export { AddModuleFn } //RemoveModuleFn, 